import { render, staticRenderFns } from "./LanguageDropdown.vue?vue&type=template&id=84250e28&scoped=true"
import script from "./LanguageDropdown.vue?vue&type=script&lang=js"
export * from "./LanguageDropdown.vue?vue&type=script&lang=js"
import style0 from "./LanguageDropdown.vue?vue&type=style&index=0&id=84250e28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84250e28",
  null
  
)

export default component.exports